import { has } from 'lodash';
import { fandomTranslate } from "src/modules/common_module";

const checkArrayOfObjectsValidity = (objArr, keys) => {
  let response = true;
  objArr.forEach(elem => {
    keys.forEach(key => {
      var x = has(elem, key);
      response &= !!x;
    });
  });
  return response;
}

const calendarMixin = {
  methods: {
    dateKey(date) {
      const d = date instanceof Date ? date : new Date(date);
      return d.toDateString().replace(/ /g, '-');
    },
    ft: fandomTranslate,
  }
}

export {
  calendarMixin,
  checkArrayOfObjectsValidity
}